// NavBar2.jsx
import { FiMenu } from "react-icons/fi";
import { IconButton, Button, Flex, Text, Spacer } from "@chakra-ui/react";
import { useSidenav } from "./SidenavContext";
import React from 'react';
import LogoutButton from '../../buttons/LogoutButton';
import { useTranslation } from 'react-i18next';
import { FaVolumeUp, FaVolumeMute } from "react-icons/fa";
import { useSound } from '../../../pages/SoundContext.jsx';
import { useAuth } from '../../../AuthContext'; // Add this import

export function NavBar2() {
    const { t } = useTranslation();
    const { onOpen } = useSidenav();
    const { soundEnabled, toggleSound } = useSound();
    const { user, isAdmin } = useAuth(); // Get user and admin status

    // Function to handle sound button click
    const handleSoundClick = () => {
        // Always enable sound when clicked
        if (!soundEnabled) {
            toggleSound();
        }
        // Only allow toggling off if admin
        else if (isAdmin()) {
            toggleSound();
        }
    };

    return (
        <Flex as="nav" p="10px" alignItems="center" bg="orange.100">
            <IconButton
                bg="orange.100"
                aria-label="menu"
                display={{ base: "flex", md: "none" }}
                onClick={onOpen}
                icon={<FiMenu />}
            />

            <Text as='b' fontSize="2xl">{t('text_villa_rhapsody')}</Text>

            <Spacer />
            <Text as='b' fontSize="xl" mr="4"> Support Hotline: +852 5423 7656</Text>

            {/* Sound button - always visible but with different behavior */}
            <Button
                onClick={handleSoundClick}
                leftIcon={soundEnabled ? <FaVolumeUp /> : <FaVolumeMute />}
                colorScheme={soundEnabled ? "green" : "red"}
                variant="solid"
                size="md"
                mr="2"
                title={!isAdmin() && soundEnabled ? "Only admin can disable sound" : ""}
                cursor={!isAdmin() && soundEnabled ? "not-allowed" : "pointer"}
                opacity={!isAdmin() && soundEnabled ? 0.7 : 1}
            >
                {soundEnabled ? t("text_sound_on") : t("text_sound_off")}
            </Button>

            <LogoutButton>{t('text_logout')}</LogoutButton>
        </Flex>
    );
}